export default "__VITE_ASSET__BKAIq3mY__"